import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
Vue.use(Vuex)
const getDefaultState = () => {
    return {
        roles: [],
        user: {},
        jwt: '',
        mail: '',
        school: {},
        account: {},
        users: [],
        originUser: {},
        timeStamp: '',
        showMobileDeviceAlert: true,
        teacherPerms: [],
        kids: [],
        kid: {},
        groups: [],
        mealTimes: [],
        grants: [],
        paymentTemplates: [],
        allergens: [],
        notes: [],
        messages: [],
        billingPatterns: [],
        storage: {},
        teachers: [],
        permissionSets: [],
        freeDays: [],
        mealTemplates: [],
        lastPath: '',
        mealsGrants: [],
        presenceGrants: [],
        warning: {},
        activityLog: {},
        notif: {},
        loading: false,
        time: 0,
        parents: [],
        schools: [],
        schoolNetwork: {},
        selectedSchool: {},
        pendingParents: [],
        region: '',
        roleStorage: {},
        serverStatus: {},
        selectedLanguage: ''
    }
}
const vuexPersist = new VuexPersist({
    key: 'web-proxy',
    storage: window.localStorage
})
export default new Vuex.Store({
    state: getDefaultState(),
    plugins: [vuexPersist.plugin],
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        setSelectedLanguage(state, selectedLanguage) {
            state.selectedLanguage = selectedLanguage
        },
        setRegion(state, region) {
            state.region = region
        },
        setOriginUser(state, payload) {
            state.originUser = payload.originUser
        },
        setRoles(state, payload) {
            state.roles = payload.roles
        },
        setAccount(state, payload) {
            state.account = payload.account
        },
        setUser(state, payload) {
            state.user = payload.user
        },
        setMail(state, mail) {
            state.mail = mail
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setJWT(state, jwt) {
            state.user.jwt = jwt
        },
        setTeacherPerms(state, perms) {
            state.teacherPerms = perms
        },
        setKids(state, kids) {
            state.kids = kids
        },
        setKid(state, kid) {
            state.kid = kid
        },
        setParents(state, parents) {
            state.parents = parents
        },
        setGroups(state, groups) {
            state.groups = groups
        },
        setMealTimes(state, mealTimes) {
            state.mealTimes = mealTimes
        },
        setGrants(state, grants) {
            state.grants = grants
        },
        setPaymentTemplates(state, paymentTemplates) {
            state.paymentTemplates = paymentTemplates
        },
        setAllergens(state, allergens) {
            state.allergens = allergens
        },
        setNotes(state, notes) {
            state.notes = notes
        },
        setTeachers(state, teachers) {
            state.teachers = teachers
        },
        setMessages(state, messages) {
            state.messages = messages
        },
        setBillingPatterns(state, billingPatterns) {
            state.billingPatterns = billingPatterns
        },
        setFreeDays(state, freeDays) {
            state.freeDays = freeDays
        },
        setMealTemplates(state, mealTemplates) {
            state.mealTemplates = mealTemplates
        },
        setPresenceGrants(state, presenceGrants) {
            state.presenceGrants = presenceGrants
        },
        setMealsGrants(state, mealsGrants) {
            state.mealsGrants = mealsGrants
        },
        setPendingParents(state, pendingParents) {
            state.pendingParents = pendingParents
        },
        setSchool(state, school) {
            state.school = school
        },
        setServerStatus(state, serverStatus) {
            state.serverStatus = serverStatus
        },
        setRoleStorage(state, roleStorage) {
            state.roleStorage = roleStorage
        },
        setPermissionSets(state, permissionSets) {
            state.permissionSets = permissionSets
        },
        setNotif(state, notif) {
            state.notif[notif.type] = notif.value
        }
    },
    actions: {
        resetStore({ commit }) {
            commit('resetState')
        }
    },
    getters: {
        getRegion: state => shouldReturnFake => {
            switch (true) {
                case state.region.includes('pl'):
                    return shouldReturnFake ? 'pl' : state.region
                case state.region == 'ac':
                    return shouldReturnFake ? 'ac' : 'de'
                case state.region == 'mx':
                    return shouldReturnFake ? 'mx' : 'sa'
                default:
                    return state.region
            }
        },
        currentRole: state => {
            return state.user
        },
        currentAccount: state => {
            return state.account
        }
    },
    modules: {}
})
